
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { VinImageUpload } from "./VinImageUpload";
import { InvoiceUpload } from "./InvoiceUpload";
import { VinResults } from "./VinResults";
import { useVinLookup } from "@/hooks/useVinLookup";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";

export const VinLookup = () => {
  const [vinInput, setVinInput] = useState("");
  const [isResultsOpen, setIsResultsOpen] = useState(false);
  const { isLoading, currentResults, lookupVin, clearResults } = useVinLookup();

  const handleVinDetected = (vin: string) => {
    console.log("VIN detected from upload:", vin);
    lookupVin(vin);
    setIsResultsOpen(true);
  };

  const handleManualSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!vinInput.trim()) {
      return;
    }
    console.log("Manual VIN lookup initiated:", vinInput);
    lookupVin(vinInput);
    setIsResultsOpen(true);
  };

  const handleCloseResults = () => {
    setIsResultsOpen(false);
    clearResults();
  };

  return (
    <div className="space-y-6">
      <form onSubmit={handleManualSubmit} className="space-y-4">
        <div className="flex gap-4">
          <Input
            placeholder="Enter VIN number"
            value={vinInput}
            onChange={(e) => setVinInput(e.target.value)}
            disabled={isLoading}
          />
          <Button type="submit" disabled={isLoading || !vinInput.trim()}>
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Loading...
              </>
            ) : (
              "Lookup"
            )}
          </Button>
        </div>

        <Tabs defaultValue="camera" className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="camera">Camera/Image</TabsTrigger>
            <TabsTrigger value="invoice">Repair Estimate</TabsTrigger>
          </TabsList>
          <TabsContent value="camera">
            <Card>
              <CardContent className="pt-6">
                <VinImageUpload
                  onVinDetected={handleVinDetected}
                  isLoading={isLoading}
                />
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="invoice">
            <Card>
              <CardContent className="pt-6">
                <InvoiceUpload
                  onVinDetected={handleVinDetected}
                  isLoading={isLoading}
                />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </form>

      {currentResults && (
        <VinResults 
          nhtsaData={currentResults.nhtsaData}
          dataOneData={currentResults.dataOneData}
          onClose={handleCloseResults}
          isOpen={isResultsOpen}
        />
      )}
    </div>
  );
};
